var d3 = require("d3");

var graph6 = function() {

var monthTicks = ["3-Mar-2020", "1-Apr-2020", "May 1", "June 1", "July 1","Aug. 1"];

var setWidth;

   if (window.innerWidth > 750 ) { setWidth = 700; }
   else if (window.innerWidth > 350) { setWidth = 320; }
   else { setWidth = 290; }


  // set the dimensions and margins of the graph
  var margin = {top: 20, right: 13, bottom: 50, left: 50},
      width =  setWidth - margin.left - margin.right,
      height = 500 - margin.top - margin.bottom;

  // parse the date / time
  var parseTime = d3.timeParse("%e-%b-%Y");
  var formatMonths = d3.timeFormat('%B');

  // set the ranges
  var x = d3.scaleTime().range([0, width]);
  var y = d3.scaleLinear().range([height, 0]);

  // define the line
  var valueline = d3.line()
      .x(function(d) { return x(d.date); })
      .y(function(d) { return y(d.PercentageChange); });

  // append the svg obgect to the body of the page
  // appends a 'group' element to 'svg'
  // moves the 'group' element to the top left margin
  var svg = d3.select("#trendGraph").append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      // .attr("viewbox", 'viewBox="0 0 200 800"')
    .append("g")
      .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");

  // Get the data
  d3.csv("assets/graphs/covidTrendLine.csv").then(function(data) {

    // format the data
    data.forEach(function(d) {
        d.date = parseTime(d.date);
        d.PercentageChange = +d.PercentageChange;
    });

    // Scale the range of the data
    x.domain(d3.extent(data, function(d) { return d.date; }));
    y.domain([ -100, 100 ]);

    // Add the valueline path.
    svg.append("path")
        .data([data])
        .attr("class", "trendLine")
        .attr("d", valueline);

    svg.append("line")
        .attr("class", "baseLine")
        .attr("x1", 0)
        .attr("x2", x( d3.max(data, function(d) { return d.date; })) )
        .attr("y1", y(0))
        .attr("y2", y(0));

    svg.append("text")
        .attr("class", "endText")
        .attr("x", x( d3.max(data, function(d) { return d.date; })) + 10 )
        .attr("y", y(-23))
        .text("Sept. 3");

    svg.append("text")
        .attr("class", "endText")
        .attr("x", x( d3.max(data, function(d) { return d.date; })) + 10 )
        .attr("y", y(-30))
        .text("-10% change");


    svg.append("text")
        .attr("class", "baseText")
        .attr("x", x(parseTime("10-Apr-2020")) )
        .attr("y", y(4))
        .text("Baseline");


    svg.append("circle")
        .attr("class", "lastDay")
        .attr("cx", x( d3.max(data, function(d) { return d.date; })) )
        .attr("cy", y(-10))
        .attr('r','5px')
        .style('fill', 'none')
        .style("stroke","red");


    svg.append("text")
        .attr("class", "july2Text")
        .attr("x", x(parseTime("2-Jul-2020")) + 2 )
        .attr("y", y(27))
        .text("*");

    svg.append("text")
        .attr("class", "aug31Text")
        .attr("x", x(parseTime("31-Aug-2020")) + 2 )
        .attr("y", y(5))
        .text("**");

    svg.append("text")
        .attr("class", "march3")
        .attr("x", -10 )
        .attr("y", height + margin.top - 3 )
        .text("March 3");

    // Add the x Axis
    svg.append("g")
        .attr("class", "xAxis")
        .attr("transform", "translate(0," + height + ")")
        .call(d3.axisBottom(x).tickSizeOuter(0).tickFormat(d => {
          var months = formatMonths(d);
          if (months === "August") {
            months = "Aug."
          } else if ( months === "September" ) {
            months = "Sept."
          } else {}

          return months;
        }));

    // Add the y Axis
    svg.append("g")
       .attr("class", "yAxis")
       .call( d3.axisLeft(y).tickFormat(d => d + "%") );

  });

}

module.exports = graph6;
